import { render, staticRenderFns } from "./registro_edicion_permisovacacion.vue?vue&type=template&id=1683fe0c&scoped=true"
import script from "./registro_edicion_permisovacacion.vue?vue&type=script&lang=js"
export * from "./registro_edicion_permisovacacion.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_permisovacacion.vue?vue&type=style&index=0&id=1683fe0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1683fe0c",
  null
  
)

export default component.exports